import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Popconfirm,
  Space,
  Card,
} from 'antd';
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getSearchApi,
  getDataApi,
  getSearchApiFilterDocstatus,
} from '../../../network/itemList';
import { queryKeys } from '../../../services/react-query/queryKeys';
const ItemList = ({
  setDataSourceItemList,
  dataSourceItemList,
  t,
  watchDistributeCharges,
  selectedIndex,
  setSelectedIndex,
  dataSourcePurchase,
  setDataSourcePurchase,
}) => {
  // console.log('dataSourcePurchasefqwfqwfwqfwqfw', dataSourcePurchase);

  const [count, setCount] = useState(0);
  const queryClient = useQueryClient();
  const { data: choiceFrom } = useQuery({
    queryKey: [queryKeys.getSearchApiChoice],
    queryFn: () => getSearchApiFilterDocstatus('Purchase Receipt'),
    keepPreviousData: true,
  });
  const { data: payrollcostcenter } = useQuery({
    queryKey: [queryKeys.getCostCenterSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.itemCode,
      dataIndex: 'item_code',
      render: (text, record, index) => (
        <Select
          placeholder={t.itemCode}
          value={record.item_code}
          onChange={(value) => {
            const newDataSource = [...dataSourceItemList];
            newDataSource[index] = {
              ...newDataSource[index],
              item_code: value,
            };
            setDataSourceItemList(newDataSource);
          }}
          style={{ width: '100%' }}
          options={[]}
          disabled
        />
      ),
    },
    {
      title: t.receiptDocumentType,
      dataIndex: 'receipt_document_type',
      render: (text, record, index) => (
        <Select
          placeholder={t.receiptDocumentType}
          disabled
          value={record.receipt_document_type}
          onChange={(value) => {
            const newDataSource = [...dataSourceItemList];
            newDataSource[index] = {
              ...newDataSource[index],
              receipt_document_type: value,
            };
            setDataSourceItemList(newDataSource);
          }}
          style={{ width: '100%' }}
          options={[
            { value: 'Purchase Invoice', label: t.purchaseInvoice },
            { value: 'Purchase Receipt', label: t.PurchaseReceipts },
          ]}
        />
      ),
    },
    {
      title: t.receiptDocument,
      dataIndex: 'receipt_document',
      render: (text, record, index) => (
        <Select
          placeholder={t.receiptDocument}
          value={record.receipt_document}
          disabled
          onChange={async (value) => {
            const newDataSource = [...dataSourceItemList];
            newDataSource[index] = {
              ...newDataSource[index],
              receipt_document: value,
            };
            setDataSourceItemList(newDataSource);
          }}
          style={{ width: '100%' }}
          options={choiceFrom?.data?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
        />
      ),
    },
    {
      title: t.applicableCharges,
      dataIndex: 'applicable_charges',
      render: (text, record, index) => (
        <Input
          placeholder={t.applicableCharges}
          style={{ width: '100%' }}
          disabled={
            watchDistributeCharges === 'Distribute Manually' ? false : true
          }
          value={record.applicableCharges}
          onChange={(e) => {
            const newDataSource = [...dataSourceItemList];
            newDataSource[index] = {
              ...newDataSource[index],
              applicableCharges: e.target.value,
            };
            setDataSourceItemList(newDataSource);
          }}
          type="number"
          min={0}
        />
      ),
    },
    {
      title: t.quantity,
      dataIndex: 'qty',
      render: (text, record, index) => (
        <Input
          placeholder={t.quantity}
          style={{ width: '100%' }}
          disabled
          value={record.qty}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.amount}
          style={{ width: '100%' }}
          disabled
          value={record.amount}
        />
      ),
    },
    {
      title: t.costCenter,
      dataIndex: 'cost_center',
      render: (text, record, index) => (
        <Select
          placeholder={t.costCenter}
          value={record.cost_center}
          disabled={
            watchDistributeCharges === 'Distribute Manually' ? false : true
          }
          onChange={(value) => {
            setSelectedIndex(record.id);
            const newDataSource = [...dataSourceItemList];
            newDataSource[index] = {
              ...newDataSource[index],
              cost_center: value,
            };
            setDataSourceItemList(newDataSource);
            setDataSourcePurchase((prevDataSource) => {
              const updatedDataSource = [...prevDataSource];
              updatedDataSource[record.id] = {
                ...updatedDataSource[record.id],
                items: updatedDataSource[record.id]?.items?.map(
                  (newItemDetail) => ({
                    ...newItemDetail,
                    cost_center: value,
                  })
                ),
              };
              return updatedDataSource;
            });
          }}
          style={{ width: '100%' }}
          options={payrollcostcenter?.message?.map((user) => ({
            value: user.value,
            label: user.value,
          }))}
        />
      ),
    },
    // {
    //   title: t.action,
    //   key: 'action',
    //   render: (text, record, index) => (
    //     <Space>
    //       <Popconfirm
    //         title={t.confirmDelete}
    //         onConfirm={() => handleDelete(record.key)}
    //       >
    //         <Button
    //           type="primary"
    //           danger
    //           icon={<DeleteOutlined />}
    //           size="small"
    //         />
    //       </Popconfirm>
    //     </Space>
    //   ),
    // },
  ];

  const handleAdd = () => {
    const newData = { key: count, due_date: dayjs(), invoice_portion: 100 };
    setDataSourceItemList([...dataSourceItemList, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceItemList.filter((item) => item.key !== key);
    setDataSourceItemList(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        // dataSource={dataSourceItemList}
        dataSource={dataSourcePurchase?.flatMap((item) =>
          item?.items?.map((item) => ({ ...item }))
        )}
        columns={columns}
        pagination={{ hideOnSinglePage: true }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      {/* <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button> */}
    </Card>
  );
};

export default ItemList;
